export default "__VITE_ASSET__Cg$FV827__"